import React, { useEffect, useMemo } from 'react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';
import SgOccupationDetails from 'sg-occupation-details';
import _ from 'lodash';
import metadata from './SgSpmAdditionalDriverOtherDetails.metadata.json5';
import './SgSpmAdditionalDriverOtherDetails.messages';

function SgSpmAdditionalDriverOtherDetails(props) {
    const {
        id,
        modelVM,
        showErrors,
        driverIndex,
        retirementDateQuestionAvailable,
        updateData,
        path,
        onValidate: onValidateParent,
        messageParams
    } = props;

    const {
        isComponentValid,
        onValidate
    } = useValidation(id);
    const commonProps = {
        modelVM, showErrors, updateData
    };
    const driverModelPath = `${path}[${driverIndex}]`;
    const driverModel = _.get(modelVM, driverModelPath);
    const { spmDrivers } = modelVM.value.lobData.privateMotor.coverables;

    const isSpouseQuestionVisible = useMemo(() => {
        if (driverModel.value.isSpouseOrPartner === true) { // Display if current driver is Spouse
            return true;
        }
        // Display only if no driver is Spouse
        return _.every(spmDrivers, (driver) => driver.isSpouseOrPartner !== true);
    }, []);

    useEffect(() => {
        if (!isSpouseQuestionVisible) { // DE54, If the question is not visible, set it to false
            driverModel.isSpouseOrPartner.value = false;
        }
    }, [isSpouseQuestionVisible]);

    useEffect(() => {
        if (onValidateParent) {
            onValidateParent(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidateParent]);

    const overrides = {
        occupationDetailsComponent: {
            name: 'occupationDetailsComponent',
            updateData,
            modelVM,
            path: `${driverModelPath}`,
            onValidate: onValidate,
            messageParams,
            retirementDateQuestionAvailable,
            ...commonProps,
            adobeIdSuffix: 'AdditionalDriver'
        },
        isSpouseOrPartner: {
            visible: isSpouseQuestionVisible,
            path: `${driverModelPath}.isSpouseOrPartner`,
            adobeID: 'spouseOrPartner'
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate
        },
        resolveComponentMap: {
            SgOccupationDetails
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            showErrors={showErrors}
            onModelChange={updateData}
            onValidationChange={onValidate}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default SgSpmAdditionalDriverOtherDetails;
